(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-bundle"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.build-bundle-block button.bbb-button-btn').forEach(btn => {
  btn.addEventListener('click', function () {
    btn.classList.add('loading');
    const formData = { items: [] };
    const bundleBlock = btn.closest('.build-bundle-block');

    if (!bundleBlock) return;

    bundleBlock.querySelectorAll('.bbb-product-content').forEach(item => {
      const id = item.dataset.vid;
      const qty = parseInt(item.dataset.qty, 10) || 1;

      if (id) {
        formData.items.push({
          id: id,
          quantity: qty,
          properties: {
            '_type': 'bundle'
          }
        });
      }
    });

    console.log('formData:', formData);

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(res => res.json())
      .then(data => {
        console.log('Cart Updated:', data);
        // Redirect to checkout
        window.cartUpdateBundle();
        setTimeout(function() {
            btn.classList.remove('loading');
        },1000);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  });
});


window.cartUpdateBundle = () => {
   const form = document.querySelector('.bundle_hero_image');
   fetch(`${window.Shopify.routes.root}cart?query=default`)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then(data => {
      // console.log(data);
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      const cartDrawer = doc.getElementById('Cart-Drawer');
      const cartDrawerHTML = cartDrawer.innerHTML;
      const cartDprice = doc.querySelector('.thb-items-price').innerHTML;
      
      document.querySelector('#Cart-Drawer').innerHTML = cartDrawerHTML;
      document.querySelector('.thb-items-price').innerHTML = cartDprice;

      $('.cart-rp-wrapper').slick({infinite: false, slidesToShow: 1,slidesToScroll: 1,arrows: true,dots: false});
      pairwithDisabled();
      
      form.closest('body').classList.add("open-cc");
      document.getElementById("Cart-Drawer").classList.add("active");
      dispatchCustomEvent("cart-drawer:open");
    })
    .catch(error => {
      console.error('There has been a problem with your fetch operation:', error);
    });
}


    // Scroll content dragging
    // const content_slider = document.querySelector('.bbb-bundle-products .bbb-product-outers.bbb-slider-bar');

    // let isDown = false;
    // let startX;
    // let scrollLeft;

    // content_slider.addEventListener('mousedown', (e) => {
    //     isDown = true;
    //     content_slider.classList.add('dragging'); // optional for cursor change
    //     startX = e.pageX - content_slider.offsetLeft;
    //     scrollLeft = content_slider.scrollLeft;
    // });

    // content_slider.addEventListener('mouseleave', () => {
    //     isDown = false;
    //     content_slider.classList.remove('dragging');
    // });

    // content_slider.addEventListener('mouseup', () => {
    //     isDown = false;
    //     content_slider.classList.remove('dragging');
    // });

    // content_slider.addEventListener('mousemove', (e) => {
    //     if (!isDown) return;
    //     e.preventDefault();
    //     const x = e.pageX - content_slider.offsetLeft;
    //     const walk = (x - startX) * 1.5; // scroll speed multiplier
    //     content_slider.scrollLeft = scrollLeft - walk;
    // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-page-grid"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.build-bundle-block button.bbb-button-btn').forEach(btn => {
  btn.addEventListener('click', function () {
    btn.classList.add('loading');
    const formData = { items: [] };
    const bundleBlock = btn.closest('.build-bundle-block');

    if (!bundleBlock) return;

    bundleBlock.querySelectorAll('.bbb-product-content').forEach(item => {
      const id = item.dataset.vid;
      const qty = parseInt(item.dataset.qty, 10) || 1;

      if (id) {
        formData.items.push({
          id: id,
          quantity: qty,
          properties: {
            '_type': 'bundle'
          }
        });
      }
    });

    console.log('formData:', formData);

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(res => res.json())
      .then(data => {
        console.log('Cart Updated:', data);
        // Redirect to checkout
        //window.cartUpdateBundle();
        const discount_code = document.querySelector('.build-bundle-wrapper').dataset.discount;
        window.location.href = `/checkout?discount=${discount_code}`;
        setTimeout(function() {
            btn.classList.remove('loading');
        },1000);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  });
});


window.cartUpdateBundle = () => {
   const form = document.querySelector('.bundle_hero_image');
   fetch(`${window.Shopify.routes.root}cart?query=default`)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then(data => {
      // console.log(data);
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      const cartDrawer = doc.getElementById('Cart-Drawer');
      const cartDrawerHTML = cartDrawer.innerHTML;
      const cartDprice = doc.querySelector('.thb-items-price').innerHTML;
      
      document.querySelector('#Cart-Drawer').innerHTML = cartDrawerHTML;
      document.querySelector('.thb-items-price').innerHTML = cartDprice;

      $('.cart-rp-wrapper').slick({infinite: false, slidesToShow: 1,slidesToScroll: 1,arrows: true,dots: false});
      pairwithDisabled();
      
      document.querySelector('body').classList.add("open-cc");
      document.getElementById("Cart-Drawer").classList.add("active");
      dispatchCustomEvent("cart-drawer:open");
    })
    .catch(error => {
      console.error('There has been a problem with your fetch operation:', error);
    });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.build-bundle-block button.bbb-button-btn').forEach(btn => {
  btn.addEventListener('click', function () {
    btn.classList.add('loading');
    const formData = { items: [] };
    const bundleBlock = btn.closest('.build-bundle-block');

    if (!bundleBlock) return;

    bundleBlock.querySelectorAll('.bbb-product-content').forEach(item => {
      const id = item.dataset.vid;
      const qty = parseInt(item.dataset.qty, 10) || 1;

      if (id) {
        formData.items.push({
          id: id,
          quantity: qty,
          properties: {
            '_type': 'bundle'
          }
        });
      }
    });

    console.log('formData:', formData);

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(res => res.json())
      .then(data => {
        console.log('Cart Updated:', data);
        // Redirect to checkout
        //window.cartUpdateBundle();
        const discount_code = document.querySelector('.build-bundle-wrapper').dataset.discount;
        window.location.href = `/checkout?discount=${discount_code}`;
        setTimeout(function() {
            btn.classList.remove('loading');
        },1000);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  });
});


window.cartUpdateBundle = () => {
   const form = document.querySelector('.bundle_hero_image');
   fetch(`${window.Shopify.routes.root}cart?query=default`)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then(data => {
      // console.log(data);
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      const cartDrawer = doc.getElementById('Cart-Drawer');
      const cartDrawerHTML = cartDrawer.innerHTML;
      const cartDprice = doc.querySelector('.thb-items-price').innerHTML;
      
      document.querySelector('#Cart-Drawer').innerHTML = cartDrawerHTML;
      document.querySelector('.thb-items-price').innerHTML = cartDprice;

      $('.cart-rp-wrapper').slick({infinite: false, slidesToShow: 1,slidesToScroll: 1,arrows: true,dots: false});
      pairwithDisabled();
      
      document.querySelector('body').classList.add("open-cc");
      document.getElementById("Cart-Drawer").classList.add("active");
      dispatchCustomEvent("cart-drawer:open");
    })
    .catch(error => {
      console.error('There has been a problem with your fetch operation:', error);
    });
}


    // Scroll content dragging
    // const content_slider = document.querySelector('.bbb-bundle-products .bbb-product-outers.bbb-slider-bar');

    // let isDown = false;
    // let startX;
    // let scrollLeft;

    // content_slider.addEventListener('mousedown', (e) => {
    //     isDown = true;
    //     content_slider.classList.add('dragging'); // optional for cursor change
    //     startX = e.pageX - content_slider.offsetLeft;
    //     scrollLeft = content_slider.scrollLeft;
    // });

    // content_slider.addEventListener('mouseleave', () => {
    //     isDown = false;
    //     content_slider.classList.remove('dragging');
    // });

    // content_slider.addEventListener('mouseup', () => {
    //     isDown = false;
    //     content_slider.classList.remove('dragging');
    // });

    // content_slider.addEventListener('mousemove', (e) => {
    //     if (!isDown) return;
    //     e.preventDefault();
    //     const x = e.pageX - content_slider.offsetLeft;
    //     const walk = (x - startX) * 1.5; // scroll speed multiplier
    //     content_slider.scrollLeft = scrollLeft - walk;
    // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glossary-main-section"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.alphabet-list-wrap button.letter-btn').forEach(button => {
    button.addEventListener('click', function () {
      const term_letter = this.dataset.id;

      const parentWrap = this.closest('.alphabet-list-wrap');

      const activeBtn = parentWrap.querySelector('button.letter-btn.active');
      if (activeBtn) {
        activeBtn.classList.remove('active');
      }

      this.classList.add('active');

      const blog_main = this.closest('.bhs_chapter_content');

      blog_main.querySelectorAll('.glossary_term.show').forEach(item => {
        item.classList.remove('show');
      });

      blog_main.querySelectorAll(`.glossary_terms-wrapper .glossary_term[data-letter="${term_letter}"]`)
        .forEach((item, i) => {
          if(i == 0){item.scrollIntoView({ behavior: 'smooth', block: 'start' });}
          item.classList.add('show');
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-base-bundle"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.build-bundle-block button.bbb-button-btn').forEach(btn => {
  btn.addEventListener('click', function () {
    btn.classList.add('loading');
    const formData = { items: [] };
    const bundleBlock = btn.closest('.build-bundle-block');

    if (!bundleBlock) return;

    bundleBlock.querySelectorAll('.bbb-product-content').forEach(item => {
      const id = item.dataset.vid;
      const qty = parseInt(item.dataset.qty, 10) || 1;

      if (id) {
        formData.items.push({
          id: id,
          quantity: qty,
          properties: {
            '_type': 'bundle'
          }
        });
      }
    });

    console.log('formData:', formData);

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(res => res.json())
      .then(data => {
        console.log('Cart Updated:', data);
        // Redirect to checkout
        //window.cartUpdateBundle();
        const discount_code = document.querySelector('.build-bundle-wrapper').dataset.discount;
        window.location.href = `/checkout?discount=${discount_code}`;
        setTimeout(function() {
            btn.classList.remove('loading');
        },1000);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  });
});


window.cartUpdateBundle = () => {
   const form = document.querySelector('.bundle_hero_image');
   fetch(`${window.Shopify.routes.root}cart?query=default`)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then(data => {
      // console.log(data);
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      const cartDrawer = doc.getElementById('Cart-Drawer');
      const cartDrawerHTML = cartDrawer.innerHTML;
      const cartDprice = doc.querySelector('.thb-items-price').innerHTML;
      
      document.querySelector('#Cart-Drawer').innerHTML = cartDrawerHTML;
      document.querySelector('.thb-items-price').innerHTML = cartDprice;

      $('.cart-rp-wrapper').slick({infinite: false, slidesToShow: 1,slidesToScroll: 1,arrows: true,dots: false});
      pairwithDisabled();
      
      document.querySelector('body').classList.add("open-cc");
      document.getElementById("Cart-Drawer").classList.add("active");
      dispatchCustomEvent("cart-drawer:open");
    })
    .catch(error => {
      console.error('There has been a problem with your fetch operation:', error);
    });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-main-article"]) return;
  try {
    
  const faqs = document.querySelectorAll(".faq-wrapper");

  faqs.forEach((faq) => {
    const question = faq.querySelector(".faq-qustion");
    const answer = faq.querySelector(".faq-answer");

    // Hide all answers initially

    question.addEventListener("click", () => {
      const isActive = faq.classList.contains("active");

      // Close all other FAQs
      faqs.forEach((f) => {
        f.classList.remove("active");
      });

      // Toggle current FAQ
      if (!isActive) {
        faq.classList.add("active");
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-and-a-article"]) return;
  try {
    
  const faqs = document.querySelectorAll(".faq-wrapper");

  faqs.forEach((faq) => {
    const question = faq.querySelector(".faq-qustion");
    const answer = faq.querySelector(".faq-answer");

    // Hide all answers initially

    question.addEventListener("click", () => {
      const isActive = faq.classList.contains("active");

      // Close all other FAQs
      faqs.forEach((f) => {
        f.classList.remove("active");
      });

      // Toggle current FAQ
      if (!isActive) {
        faq.classList.add("active");
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["save-up-to"] && !Shopify.designMode) return;
  try {
    
  $('.save-up-to-wrapper').slick({
  speed: 5000,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: 'linear',
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  arrows: false,
  dots: false,
  pauseOnHover: false,
  variableWidth: true
});


  } catch(e) { console.error(e); }
})();
})();
